import React from 'react';
import styles from './header.module.scss';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux'; // State has URLs for links

import logo from 'images/btis-25-logo.png';

// Retrieve environmentConfig from store
const mapStateToProps = (state /*, ownProps*/) => {
  return {
    urls: state.url
  };
};

const Header = function simple_html_bootstrap_nav(props) {
  const menuItems = [
    {
      heading: 'Products',
      url: 'https://marketplace.btisinc.com/products/'
    },
    {
      heading: 'Tools & Resources',
      url: 'https://marketplace.btisinc.com/producer-tools/btis-benefits/'
    },
    {
      heading: 'About',
      url: 'https://marketplace.btisinc.com/about-btis/'
    },
    {heading:"Norbie's News",
      url:'https://marketplace.btisinc.com/norbies-news-2/'
    },
    {
      heading: 'Register',
      url: 'https://marketplace.btisinc.com/register/'
    },
    {
      heading:'Shop Marketplace',
      url:'https://my.btisinc.com/submissions'
    }
  ];

  return (
    <>
      <nav className={styles.siteNavigation} aria-label="Site Navigation" itemtype="https://schema.org/SiteNavigationElement" itemscope="itemscope">
        <div className={styles.mainNavigation}>
          <ul>
            <li className="menu-item menu-item-type-custom menu-item-object-custom">
              <a rel="noopener" href="https://my.btisinc.com/m-login" class="menu-link">Login</a>
            </li>
            <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-2003">
              <a href="https://marketplace.btisinc.com/register/" class="menu-link">Register</a>
            </li>
          </ul>
        </div>
      </nav>
      <nav className={`${styles.navbar} navbar-expand-lg navbar-light mb-4`}>{/*"navbar navbar-expand-lg navbar-light mb-4" */}
        <a className="navbar-brand" href="https://marketplace.btisinc.com">
          <img src={logo} width="232px" height="86px" alt={'BTIS Logo'} />
        </a>
        <div className="collapse navbar-collapse">
          <ul className="navbar-nav flex-wrap">
            {menuItems.map(item => (
              <li className={`nav-item px-3 ${styles.sidebarNavList}`} key={item.heading}>
                <a
                  className={`nav-link ${styles.customenavlink}`}
                  href={item.url}
                >
                  {item.heading}
                </a>
              </li>
            ))}
          </ul>
        </div>
      </nav>
    </>
  );
};

export default withRouter(connect(mapStateToProps)(Header));
